import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  CandidateProfileTab,
  getCandidateProfileTabs
} from 'modules/candidate-profile/utils/getCandidateProfileTabs';
import { TabsV2 } from 'common/ui/TabsV2';
import { getCandidateProfileTabComponents } from 'modules/candidate-profile/tabs/getCandidateProfileTabComponents';
import { CandidateProfileDetails } from 'modules/candidate-profile/types/CandidateProfileDetails';
import { useGetCandidateProfileDetailsTabsData } from 'modules/candidate-profile/hooks/useGetCandidateProfileDetailsTabsData';
import { useCandidateProfileStore } from 'modules/candidate-profile/stores/useCandidateProfileStore';
import { CONVERSATION_ID_PARAM } from 'modules/candidate-profile/constants';

type CandidateProfileDetailTabsProps = {
  candidateProfileId: string;
  candidateProfile: CandidateProfileDetails | null;
};

export const CandidateProfileDetailTabs: React.FC<
  CandidateProfileDetailTabsProps
> = ({ candidateProfileId, candidateProfile }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<CandidateProfileTab>(
    searchParams.get(CONVERSATION_ID_PARAM) ? 'Other campaigns' : 'Profile'
  );
  useGetCandidateProfileDetailsTabsData({ candidateProfileId });

  const {
    sourcedCandidates,
    analysedApplications,
    conversations,
    attachments
  } = useCandidateProfileStore();

  const tabs = getCandidateProfileTabs({
    invitedCount: sourcedCandidates?.length,
    appliedCount: analysedApplications?.length,
    documentsCount: attachments?.length,
    'other campaignsCount': conversations?.length
  });

  return (
    <>
      <TabsV2
        containerSx={{
          mb: '30px'
        }}
        tabs={tabs}
        value={activeTab}
        onChange={(value) => {
          setActiveTab(value as CandidateProfileTab);
          if (
            value === 'Other campaigns' ||
            !searchParams.has(CONVERSATION_ID_PARAM)
          ) {
            return;
          }
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete(CONVERSATION_ID_PARAM);
          setSearchParams(newSearchParams, { replace: true });
        }}
      />
      {getCandidateProfileTabComponents({ candidateProfile })[activeTab]}
    </>
  );
};
